import React from 'react';
import { ExternalLink } from '../../../components';
import css from '../TermsOfServicePage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function ConsumerTermsGerman() {
  const history = useHistory();
  return (
    <div className="terms-page">
      <h1>Nutzungsbedingungen für Verbraucher</h1>

      <h2>DOKUMENTINFORMATIONEN</h2>
      <p>
        Gilt für: Verbraucher (Nutzer), die über die Plattform Dienstleistungen suchen oder buchen
        <br />
        Letzte Änderung: 12.05.2025
        <br />
        Verwandte Dokumente:{' '}
        <span
          className={css.termsLink}
          role="button"
          onClick={() => history.push('/de/terms-of-service?tab=professional')}
        >
          Nutzungsbedingungen für gewerbliche Nutzer
        </span>{' '}
        | <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink>
      </p>

      <h2>Präambel</h2>
      <p>
        Diese Nutzungsbedingungen gelten ausschließlich für Verbraucher (im Folgenden auch als
        „Nutzer“ bezeichnet), die sich registrieren und die Website unter www.vivianlab.gr,
        www.vivianlab.com und www.vivianlab.health sowie die dazugehörigen mobilen Anwendungen
        (zusammenfassend als „Plattform“ bezeichnet) nutzen, um Dienstleistungen zu suchen, zu buchen
        oder in Anspruch zu nehmen.
      </p>
      <p>
        Die Plattform ist Eigentum des Unternehmens mit dem Namen „VIVIANLAB LTD“ und dem Markennamen
        „Vivian Lab“ mit Sitz in 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1, VAT BG207933919,
        E-Mail-Kontakt info@vivianlab.com (das „Unternehmen“).
      </p>
      <p>
        Alle Inhalte, Marken und Domainnamen (einschließlich www.vivianlab.gr, www.vivianlab.com und
        www.vivianlab.health) sind das ausschließliche Eigentum des Unternehmens und durch Urheber-,
        Marken- und andere geltende Gesetze zum Schutz geistigen Eigentums geschützt.
      </p>
      <p>
        Das Unternehmen verpflichtet sich, sicherzustellen, dass die Plattform für alle Nutzer,
        einschließlich Menschen mit Behinderungen, gemäß dem Europäischen Gesetz zur Barrierefreiheit
        (Richtlinie (EU) 2019/882) und den einschlägigen technischen Standards zugänglich ist.
      </p>
      <p>
        Haftungsausschluss zu medizinischen und KI-bezogenen Inhalten: Die Plattform bietet Tools an,
        die Einblicke in das Wohlbefinden, die Symptomverfolgung oder KI-gestützte Anleitungen liefern
        können. Diese Tools stellen keine medizinische Beratung, Diagnose oder Behandlung dar und
        ersetzen nicht die Konsultation eines zugelassenen medizinischen Fachpersonals. Die Plattform
        ist nicht für medizinische Notfälle oder dringende gesundheitliche Situationen vorgesehen.
        Bei schweren Symptomen müssen Sie unverzüglich einen Arzt oder den Rettungsdienst
        kontaktieren.
      </p>
      <p>
        Globaler rechtlicher Hinweis (EU &amp; USA): Die Plattform und ihre Dienste dienen
        ausschließlich allgemeinen Wellness- und Informationszwecken und sind weder als
        Medizinprodukt gemäß der Verordnung (EU) 2017/745 eingestuft noch unterliegen sie der
        Regulierung durch die US-amerikanische Food and Drug Administration (FDA). Die Plattform
        bietet unter keiner Rechtsordnung medizinische Beratung, Diagnose oder Behandlung an.
      </p>
      <p>
        Transparenz des KI-Systems und menschliche Aufsicht: Die auf der Plattform verfügbaren
        KI-Funktionen arbeiten in Echtzeit ohne menschliche Aufsicht und beinhalten keine Überprüfung
        der einzelnen Ergebnisse durch Menschen. Das System generiert Antworten auf der Grundlage von
        Datenmustern und kann Ergebnisse liefern, die ungenau, unvollständig oder irreführend sind.
        Nutzer müssen alle Informationen unabhängig überprüfen, bevor sie darauf reagieren.
      </p>

      <h2>1. DEFINITIONEN</h2>
      <p>Im Sinne dieser Nutzungsbedingungen gelten folgende Definitionen:</p>
      <ul>
        <li>
          <strong>„Verbraucher“ oder „Nutzer“:</strong> Jede Person, die die Plattform nutzt, um
          Dienstleistungen oder digitale Inhalte professioneller Nutzer:innen zu suchen, zu buchen oder
          zu erhalten.
        </li>
        <li>
          <strong>„Professioneller Nutzer“ oder „Anbieter“:</strong> Jede natürliche oder juristische
          Person, die auf der Plattform registriert ist, um professionelle Dienstleistungen anzubieten
          (einschließlich Gesundheitsexperten, Berater und Unternehmen im Gesundheits- und
          Wellnessbereich). Das Unternehmen überprüft oder garantiert die medizinische Zulassung,
          Kompetenz oder regulatorische Konformität professioneller Nutzer nicht, sofern dies nicht
          ausdrücklich angegeben wird.
        </li>
        <li>
          <strong>„Plattform“ oder „Marktplatz“:</strong> Die unter dem Markennamen VivianLab
          betriebene Online-Umgebung, zugänglich über Websites und mobile Anwendungen.
        </li>
        <li>
          <strong>„Unternehmen“:</strong> Die juristische Person, die Eigentümerin der Plattform ist
          und diese betreibt.
        </li>
        <li>
          <strong>„Dienstleistungen“:</strong> Sämtliche Vermittlungsleistungen, die das Unternehmen
          über die Plattform anbietet, einschließlich der Darstellung professioneller Profile,
          Terminbuchungen, Videoberatungen, Bildungsinhalten und KI-gestützter Funktionen.
        </li>
        <li>
          <strong>„KI-Tools“:</strong> Automatisierte digitale Tools, die über die Plattform
          bereitgestellt werden und wellnessbezogene Vorschläge, Bildungsinhalte oder Symptom-Einblicke
          auf Grundlage von durch Nutzer:innen bereitgestellten Daten generieren. KI-Tools dienen
          ausschließlich Informationszwecken und bieten weder medizinische Diagnosen noch klinische
          Entscheidungsfindung.
        </li>
        <li>
          <strong>„KI-System“:</strong> Jedes vom Unternehmen entwickelte oder integrierte
          Softwaresystem, das Ergebnisse wie Vorhersagen, Empfehlungen oder Inhalte erzeugt, die
          Nutzerentscheidungen beeinflussen, im Sinne des EU-Gesetzes über künstliche Intelligenz.
        </li>
        <li>
          <strong>„Vereinbarung“:</strong> Diese Nutzungsbedingungen zusammen mit der{' '}
          <ExternalLink href="/de/privacy-policy">Datenschutzrichtlinie</ExternalLink>.
        </li>
        <li>
          <strong>„Werktage“:</strong> Jeder Tag außer Samstag, Sonntag oder gesetzlichen Feiertagen in
          Griechenland.
        </li>
        <li>
          <strong>„Sitzung“ oder „Termin“:</strong> Eine über die Plattform vereinbarte Beratung oder
          Leistungserbringung zwischen einem Verbraucher und einem gewerblichen Nutzer.
        </li>
        <li>
          <strong>„Abonnement“:</strong> Kostenpflichtiger Zugang zu Premium-Funktionen und Inhalten
          der Plattform (monatlich oder jährlich).
        </li>
      </ul>

      <h2>2. ANNAHME DER BEDINGUNGEN</h2>
      <p>
        Durch die Registrierung auf oder die Nutzung der Plattform akzeptieren Sie (der Verbraucher)
        vollständig und vorbehaltlos:
      </p>
      <ol>
        <li>diese Nutzungsbedingungen für Verbraucher:innen,</li>
        <li>
          die <ExternalLink href="/de/privacy-policy">Datenschutzrichtlinie</ExternalLink> sowie
        </li>
        <li>
          die <ExternalLink href="/de/cookie-policy">Cookie-Richtlinie</ExternalLink>.
        </li>
        <li>
          Durch die Nutzung der KI-Funktionen der Plattform erkennen Sie an, dass Antworten durch
          automatisierte Systeme generiert werden und gelegentlich ungenau oder unvollständig sein
          können. Sie erklären sich damit einverstanden, KI-generierte Inhalte nicht als Grundlage für
          medizinische Entscheidungen zu verwenden.
        </li>
        <li>
          Sie erkennen an, dass KI-Ausgaben automatisch ohne menschliches Eingreifen erzeugt werden und
          möglicherweise keine genauen, vollständigen oder aktuellen Informationen darstellen. Sie
          übernehmen die volle Verantwortung für sämtliche Entscheidungen oder Handlungen, die auf
          KI-generierten Inhalten basieren.
        </li>
      </ol>
      <p>Wenn Sie diese Bedingungen nicht akzeptieren, dürfen Sie sich nicht registrieren oder die Plattform nutzen.</p>

      <h2>3. DATENSCHUTZ</h2>
      <p>
        Das Unternehmen fungiert als Verantwortlicher für personenbezogene Daten, die Sie dem
        Unternehmen direkt zur Verfügung stellen, unter anderem zu folgenden Zwecken:
      </p>
      <ul>
        <li>Einrichtung und Verwaltung Ihres Verbraucherkontos</li>
        <li>Abwicklung von Zahlungen für Abonnements und Termine</li>
        <li>Versendung von Newslettern und Marketingmitteilungen (mit Ihrer Einwilligung)</li>
        <li>Plattformverwaltung und -sicherheit</li>
      </ul>
      <p>
        Wenn Sie Dienstleistungen bei einem professionellen Nutzer buchen, fungiert dieser als
        Verantwortlicher für personenbezogene Daten im Zusammenhang mit dieser Dienstleistung oder
        Beratung. Das Unternehmen kann diese Daten im Auftrag des professionellen Nutzers als
        Auftragsverarbeiter verarbeiten. Die Plattform verarbeitet Daten in Bezug auf die Menopause,
        hormonelle Gesundheit, Symptome und das Wohlbefinden, die gemäß Artikel 9 DSGVO als Daten
        besonderer Kategorien gelten können. Diese Daten werden nur mit Ihrer ausdrücklichen
        Einwilligung und ausschließlich zum Zweck der Bereitstellung der Dienste der Plattform, der
        KI-Tools und personalisierter Wellness-Einblicke verarbeitet.
      </p>
      <p>
        KI-Ergebnisse können auf aggregierten oder pseudonymisierten Daten basieren. Das Unternehmen
        verwendet Ihre Gesundheitsdaten nicht für automatisierte Entscheidungen, die rechtliche
        Auswirkungen haben.
      </p>
      <p>
        Alle Informationen zu Zwecken, Rechtsgrundlagen für die Verarbeitung, Aufbewahrungsfristen,
        Datenempfängern und Ihren Rechten als betroffene Person sind in unserer{' '}
        <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> ausführlich
        dargelegt.
      </p>
      <p>
        <strong>Transparenz bei der KI-Verarbeitung:</strong> Das Unternehmen nutzt KI-Systeme zur
        Verarbeitung von durch Nutzer bereitgestellten Daten (einschließlich gesundheitsbezogener
        Eingaben, sofern zutreffend), um Erkenntnisse und Empfehlungen zum Wohlbefinden zu generieren.
        Diese Verarbeitung beinhaltet keine Profilerstellung, die rechtliche oder ähnlich schwerwiegende
        Auswirkungen gemäß Artikel 22 DSGVO hat. KI-Ergebnisse werden nicht verwendet, um Entscheidungen
        zu treffen, die Ihre gesetzlichen Rechte, Ihren Zugang zu Dienstleistungen oder Ihre finanzielle
        Situation betreffen.
      </p>
      <p>
        <strong>Einhaltung internationaler Datenschutzbestimmungen:</strong> Wenn Nutzer außerhalb des
        Europäischen Wirtschaftsraums, einschließlich der Vereinigten Staaten, auf die Plattform
        zugreifen, wendet das Unternehmen Datenschutzstandards an, die mit den geltenden Gesetzen,
        einschließlich der DSGVO und gegebenenfalls der einschlägigen Datenschutzgesetze der
        US-Bundesstaaten, im Einklang stehen.
      </p>

      <h3>3.1 Profilbilder &amp; Kamerazugriff</h3>
      <ul>
        <li>
          Wir können Zugriff auf die Kamera Ihres Geräts oder Ihre Fotomediathek anfordern, ausschließlich
          damit Sie ein Profilbild aufnehmen oder hochladen können. Dieser Zugriff ist optional und
          erfordert Ihre ausdrückliche Zustimmung, die Sie in den Geräteeinstellungen widerrufen können.
        </li>
        <li>
          Wir erfassen nur das von Ihnen ausgewählte Profilbild. Es wird ausschließlich zur Anzeige
          Ihres Profils innerhalb der Plattform verwendet und nicht für Werbung, Analysen oder
          Gesichtserkennung.
        </li>
        <li>
          Profilbilder werden sicher gespeichert, und Sie können Ihr Profilbild jederzeit in Ihrem
          Konto aktualisieren, ersetzen oder entfernen.
        </li>
      </ul>

      <h2>4. ONLINE-DIENSTLEISTUNGEN DER PLATTFORM</h2>
      <p>
        Die Plattform ist ein Vermittlungsmarktplatz, der sich auf Gesundheit, Wellness und damit
        verbundene Beratungsdienstleistungen spezialisiert hat. Die Plattform erbringt selbst keine
        medizinischen, gesundheitlichen oder professionellen Dienstleistungen; sie stellt lediglich die
        technischen Mittel bereit, damit Verbraucher mit professionellen Nutzern in Kontakt treten und
        Dienstleistungen von diesen in Anspruch nehmen können. Kein Medizinprodukt: Die Plattform,
        einschließlich ihrer KI-Tools, ist nicht als Medizinprodukt im Sinne der EU-Medizinprodukteverordnung
        (EU) 2017/745 eingestuft und darf nicht zur Diagnose, Behandlung oder klinischen Risikobewertung
        verwendet werden.
      </p>
      <p>Zu den über die Plattform verfügbaren Dienstleistungen gehören:</p>

      <h3>4.1 Kostenlose Dienstleistungen</h3>
      <ul>
        <li>
          Durchsuchen von Expertenprofilen (Kontaktdaten, Qualifikationen, Spezialisierungen, angebotene
          Dienstleistungen, Preise, Arbeitszeiten).
        </li>
        <li>Zugriff auf Bildungsinhalte (Artikel, Videos, Rezepte).</li>
        <li>
          Nutzung KI-gestützter Tools (Symptomverfolgung, personalisierte Beratung). KI-gestützte Tools
          können auf Grundlage von Nutzereingaben Vorschläge zum Wohlbefinden generieren. Diese
          Vorschläge sind allgemeiner Natur, nicht klinisch, können Ungenauigkeiten enthalten und dürfen
          die Konsultation qualifizierter medizinischer Fachkräfte nicht ersetzen.
        </li>
        <li>Teilnahme an kostenlosen Gruppen-Webinaren und Hotlines.</li>
        <li>
          KI-Tools sind nicht deterministische Systeme und können bei gleicher Eingabe unterschiedliche
          Ergebnisse generieren. Das Unternehmen übernimmt keine Gewähr für die Konsistenz, Genauigkeit
          oder Zuverlässigkeit von KI-generierten Inhalten. KI-generierte Ergebnisse können variieren und
          sollten unter keinen Umständen als professionelle, medizinische oder gesetzlich geregelte
          Beratung ausgelegt werden.
        </li>
      </ul>

      <h3>4.2 Abonnement-Dienstleistungen</h3>
      <p>Der Zugang zu bestimmten Premium-Funktionen und -Inhalten erfordert ein kostenpflichtiges Abonnement.</p>
      <p>Die Kosten betragen 5 € pro Monat.</p>
      <p>Zu den Abonnement-Funktionen gehören:</p>
      <ul>
        <li>Zugang zu exklusiven Artikeln, Videos und Rezepten</li>
        <li>Teilnahme an Premium-Webinaren und Gruppensitzungen</li>
        <li>Erweiterte KI-Tools und personalisierte Inhalte</li>
      </ul>
      <p>Abonnementbedingungen:</p>
      <ul>
        <li>
          Kostenlose Testphase: Ihr Abonnement beginnt mit einer 14-tägigen kostenlosen Testphase. Nach
          Ablauf der Testphase wird Ihnen automatisch die volle Abonnementgebühr in Rechnung gestellt,
          sofern Sie nicht mindestens 24 Stunden vor Ablauf der Testphase kündigen.
        </li>
        <li>
          Automatische Verlängerung: Abonnements verlängern sich automatisch, sofern sie nicht mindestens
          24 Stunden vor dem Verlängerungsdatum gekündigt werden.
        </li>
        <li>Rückerstattungsrichtlinie: Abonnementgebühren sind nicht erstattungsfähig.</li>
        <li>
          Kündigung: Sie können Ihr Abonnement jederzeit über Ihre Kontoeinstellungen oder durch
          Kontaktaufnahme mit dem Unternehmen kündigen.
        </li>
      </ul>

      <h3>4.3 Individuelle Sitzungen</h3>
      <p>Verbraucher können Einzelberatungen bei professionellen Nutzern buchen. Diese Sitzungen:</p>
      <ul>
        <li>werden separat von der Abonnementgebühr berechnet</li>
        <li>werden vom professionellen Nutzer (nicht vom Unternehmen) berechnet</li>
        <li>
          finden per Videoanruf (Google Meet oder das plattformeigene System) oder Chat statt
        </li>
      </ul>
      <p>
        Das Unternehmen verpflichtet sich, sicherzustellen, dass die Plattform und die Mittel zur
        Erbringung von Online-Diensten vertragsgemäß sind und für die Zwecke geeignet sind, für die
        digitale Vermittlungsdienste normalerweise genutzt werden, und zwar mit der erwarteten
        beruflichen Sorgfalt und Fachkenntnis.
      </p>

      <h3>4.4 EINSCHRÄNKUNGEN DES KI-SYSTEMS UND VERANTWORTUNG DER NUTZER</h3>
      <p>
        Die über die Plattform bereitgestellten KI-Funktionen dienen ausschließlich dem allgemeinen
        Wohlbefinden und zu Informationszwecken. Sie sind nicht dazu gedacht, professionelle medizinische
        Beurteilungen, Diagnosen oder Behandlungen zu ersetzen. Die Nutzer erkennen Folgendes an:
      </p>
      <ul>
        <li>KI-Ergebnisse können ungenau, unvollständig, verzerrt oder veraltet sein.</li>
        <li>Die KI hat keinen Einblick in die individuelle Krankengeschichte, sofern diese nicht ausdrücklich angegeben wird.</li>
        <li>Die KI ist nicht in der Lage, Notfälle oder kritische Gesundheitszustände einzuschätzen.</li>
      </ul>
      <p>
        Die Nutzer tragen die alleinige Verantwortung für die Bewertung der KI-Ergebnisse und müssen
        qualifizierte Fachkräfte konsultieren, bevor sie gesundheitsbezogene Entscheidungen treffen.
      </p>

      <h2>5. VERPFLICHTUNGEN DER VERBRAUCHER</h2>
      <h3>5.1 Registrierungs- und Kontovoraussetzungen</h3>
      <p>Verbraucher müssen:</p>
      <ul>
        <li>
          bei der Registrierung korrekte, vollständige und aktuelle Angaben machen, darunter:
          <ul>
            <li>vollständiger Name</li>
            <li>E-Mail-Adresse</li>
            <li>Kontaktdaten</li>
            <li>Zahlungsdaten (für Abonnements und Termine)</li>
          </ul>
        </li>
        <li>ihr Profil unverzüglich aktualisieren, wenn sich Angaben ändern</li>
      </ul>
      <p>
        Der Verbraucher ist allein dafür verantwortlich, wahrheitsgemäße und korrekte Angaben zu
        machen. Der Verbraucher haftet für alle Schäden, die dem Unternehmen aufgrund eines Verstoßes
        gegen diese Verpflichtung entstehen.
      </p>
      <h3>5.2 Kontosicherheit</h3>
      <p>
        Die Verbraucher sind für die Wahrung der Vertraulichkeit und Sicherheit ihrer Zugangsdaten,
        einschließlich Passwörtern und Authentifizierungsdaten, verantwortlich. Die Verbraucher müssen
        sichere, einmalige Passwörter wählen und angemessene Maßnahmen ergreifen, um ihre Konten vor
        unbefugtem Zugriff zu schützen. Das Unternehmen haftet nicht für Verluste oder Schäden, die
        dadurch entstehen, dass ein Verbraucher diesen Verpflichtungen zur Kontosicherheit nicht
        nachkommt.
      </p>
      <h3>5.3 Rechtmäßige Nutzung</h3>
      <p>Verbraucher müssen:</p>
      <ul>
        <li>die Plattform rechtmäßig und in Übereinstimmung mit diesen Nutzungsbedingungen nutzen</li>
        <li>keine betrügerischen Handlungen vornehmen oder die Plattform missbrauchen</li>
        <li>die Rechte von professionellen Nutzern und anderen Verbrauchern respektieren</li>
        <li>in gutem Glauben und respektvoll handeln</li>
      </ul>
      <p>
        Verbraucher dürfen sich bei medizinischen Entscheidungen oder in Notfällen nicht auf
        KI-generierte Informationen verlassen. Verbraucher müssen die Plattform verantwortungsbewusst
        nutzen und für medizinische Beratung zugelassene Fachkräfte konsultieren.
      </p>
      <p>
        Nutzer dürfen nicht versuchen, das KI-System in einer Weise zu manipulieren, auszunutzen oder
        zu testen, die zu schädlichen, irreführenden oder unsicheren Ergebnissen führen könnte.
      </p>

      <h2>6. BUCHUNGS- UND ZAHLUNGSBEDINGUNGEN</h2>
      <h3>6.1 Terminbuchung</h3>
      <p>So buchen Sie eine Einzelberatung bei einem professionellen Berater:</p>
      <ol>
        <li>Durchsuchen Sie die Profile der professionellen Berater</li>
        <li>Wählen Sie einen professionellen Berater und einen freien Termin aus</li>
        <li>Geben Sie die erforderlichen Informationen an (Name, Kontaktdaten, Grund für die Beratung)</li>
        <li>Bestätigen Sie die Buchung und wählen Sie eine Zahlungsmethode aus</li>
      </ol>
      <p>Nach der Buchung erhalten Sie eine Bestätigungs-E-Mail mit den Terminangaben.</p>
      <h3>6.2 Zahlungsabwicklung</h3>
      <p>
        Zahlungen werden über Stripe, einen externen Zahlungsdienstleister, abgewickelt. Mit der
        Eingabe Ihrer Zahlungsdaten akzeptieren Sie die Allgemeinen Geschäftsbedingungen von Stripe.
      </p>
      <p>
        Das Unternehmen wickelt Zahlungen nicht direkt ab und ist nicht für Probleme bei der
        Zahlungsabwicklung verantwortlich. Bei Streitigkeiten im Zusammenhang mit den Dienstleistungen
        von professionellen Nutzern fungiert das Unternehmen lediglich als Vermittler und ist nicht für
        die Qualität, Eignung oder das Ergebnis dieser Dienstleistungen verantwortlich.
      </p>
      <p>Zahlungsablauf:</p>
      <ul>
        <li>
          Wenn Sie einen Termin buchen, wird Ihre Kreditkarte vorläufig autorisiert (es erfolgt keine
          Belastung).
        </li>
        <li>Nach der Sitzung bestätigt der professionelle Nutzer den Abschluss.</li>
        <li>Nach der Bestätigung wird Ihre Karte belastet und der Betrag an den professionellen Nutzer überwiesen.</li>
      </ul>
      <p>
        Wenn der professionelle Nutzer die Zahlung nicht innerhalb von 7 Tagen bestätigt, wird die
        vorläufige Autorisierung aufgehoben und es erfolgt keine Belastung.
      </p>
      <h3>6.3 Preise</h3>
      <ul>
        <li>Die Abonnementgebühren werden vom Unternehmen festgelegt und auf der Plattform angezeigt.</li>
        <li>
          Die Gebühren für einzelne Sitzungen werden vom professionellen Nutzer festgelegt und in dessen
          Profil angezeigt.
        </li>
      </ul>
      <p>
        Das Unternehmen hat keinen Einfluss auf die Preisgestaltung der professionellen Nutzer und
        überprüft diese auch nicht.
      </p>
      <h3>6.4 Belege und Rechnungen</h3>
      <ul>
        <li>Bei Abonnements: Das Unternehmen stellt eine Quittung oder Rechnung aus.</li>
        <li>Bei Einzelsitzungen: Der professionelle Nutzer ist für die Ausstellung einer Quittung oder Rechnung verantwortlich.</li>
      </ul>
      <p>
        Professionelle Nutzer sind verpflichtet, für Einzelsitzungen ordnungsgemäße Steuerbelege
        (Quittungen oder Rechnungen) gemäß den geltenden Steuer- und Rechnungslegungsvorschriften
        auszustellen. Das Unternehmen übernimmt keine Verantwortung für steuerliche, lizenzrechtliche
        oder aufsichtsrechtliche Verpflichtungen der professionellen Nutzer.
      </p>
      <h3>6.5 Gutscheine und Aktionscodes</h3>
      <p>
        Das Unternehmen kann Gutscheine oder Aktionscodes anbieten, durch die die Kosten für Sitzungen
        oder Abonnements reduziert oder ganz erlassen werden. Gutscheine und Aktionscodes:
      </p>
      <ul>
        <li>unterliegen besonderen Geschäftsbedingungen (die zum Zeitpunkt der Ausstellung angezeigt werden)</li>
        <li>können ein Ablaufdatum oder Nutzungsbeschränkungen haben</li>
        <li>können nicht mit anderen Angeboten kombiniert werden, sofern nicht ausdrücklich anders angegeben</li>
        <li>sind nicht übertragbar und haben keinen Barwert</li>
      </ul>

      <h2>7. WIDERRUFSRECHT</h2>
      <p>
        Bei Dienstleistungen, die innerhalb der 14-tägigen Widerrufsfrist beginnen (z. B. ein Termin
        oder der Zugang zu digitalen Premium-Inhalten), erklären Sie sich damit einverstanden, dass Sie
        mit der Inanspruchnahme der Dienstleistung gemäß den Bestimmungen des EU-Verbraucherschutzrechts
        ausdrücklich auf Ihr Widerrufsrecht verzichten. Als Verbraucher haben Sie das Recht, innerhalb
        von 14 Kalendertagen ab dem Datum der Buchung oder des Kaufs von einem vereinbarten Termin oder
        einem Abonnement zurückzutreten, es sei denn:
      </p>
      <ul>
        <li>die Dienstleistung bereits erbracht wurde; oder</li>
        <li>
          Sie ausdrücklich der Erbringung der Dienstleistung während der Widerrufsfrist zustimmen und den
          Verlust des Widerrufsrechts anerkennen.
        </li>
      </ul>
      <h3>7.1 Widerruf von Terminen</h3>
      <p>Stornierungsbedingungen:</p>
      <ul>
        <li>Mehr als 24 Stunden vor dem Termin: Volle Rückerstattung</li>
        <li>
          Weniger als 24 Stunden, aber mehr als 60 Minuten vor dem Termin: Es können Stornierungsgebühren
          anfallen
        </li>
        <li>Weniger als 60 Minuten vor dem Termin: Keine Rückerstattung</li>
      </ul>
      <p>
        Um einen Termin zu stornieren, wenden Sie sich bitte an das Unternehmen oder nutzen Sie die
        Stornierungsfunktion in Ihrem Konto.
      </p>
      <p>
        Aufgrund von Bearbeitungsvorgaben kann es bis zu 14 Werktage dauern, bis die Rückerstattung auf
        Ihrem Konto gutgeschrieben wird.
      </p>
      <h3>7.2 Widerruf digitaler Inhalte</h3>
      <p>
        Für digitale Inhalte zum Herunterladen (z. B. Artikel, E-Books, Videos): Mit dem Herunterladen
        verzichten Sie ausdrücklich auf Ihr Widerrufsrecht.
      </p>
      <h3>7.3 Widerruf von Abonnements</h3>
      <p>
        Abonnementgebühren sind in der Regel nicht erstattungsfähig. Sie können Ihr Abonnement jedoch
        jederzeit kündigen, um eine Verlängerung zu verhindern.
      </p>
      <p>
        Die von der KI generierten Ergebnisse werden ohne menschliche Überprüfung erstellt und spiegeln
        möglicherweise nicht die tatsächliche Genauigkeit oder individuelle Umstände wider.
      </p>

      <h2>8. RÜCKERSTATTUNGEN UND STREITIGKEITEN</h2>
      <h3>8.1 Rückerstattungen bei Nichterfüllung</h3>
      <p>
        Wenn Sie der Ansicht sind, dass ein professioneller Nutzer eine Dienstleistung nicht wie vereinbart
        erbracht oder abgeschlossen hat, können Sie eine Rückerstattung beantragen, indem Sie sich unter{' '}
        <ExternalLink href="mailto:info@vivianlab.com">info@vivianlab.com</ExternalLink> an das
        Unternehmen wenden.
      </p>
      <p>
        Das Unternehmen wird den Sachverhalt prüfen und gegebenenfalls eine Rückerstattung gewähren,
        wenn es auf der Grundlage von Belegen und nach Benachrichtigung des professionellen Nutzers sowie
        Gewährung einer Gelegenheit zur Stellungnahme feststellt, dass die Dienstleistung nicht erbracht
        wurde.
      </p>
      <p>
        Das Unternehmen wird Ihnen auf Anfrage eine kurze Begründung für die Entscheidung zur
        Rückerstattung zukommen lassen, sofern dies nicht gesetzlich untersagt oder zur Betrugsbekämpfung
        erforderlich ist.
      </p>
      <h3>8.2 Technische Probleme</h3>
      <p>
        Sollte ein technisches Problem Sie oder den professionellen Nutzer daran hindern, an einer
        geplanten Sitzung teilzunehmen (z. B. eine Störung der Plattform oder eine
        Verbindungsunterbrechung), kann das Unternehmen die Sitzung nach eigenem Ermessen absagen. In
        solchen Fällen:
      </p>
      <ul>
        <li>fallen keine Kosten an.</li>
        <li>kann die Sitzung kostenlos verschoben werden.</li>
      </ul>
      <p>
        Technische Störungen, die auf das Gerät, die Internetverbindung oder die Softwarekonfiguration des
        Nutzers zurückzuführen sind, stellen keinen automatischen Grund für eine Rückerstattung dar. Dies
        liegt im alleinigen Ermessen des Unternehmens.
      </p>

      <h2>9. VERBOTENES VERHALTEN</h2>
      <p>Verbraucher dürfen nicht:</p>
      <ul>
        <li>Gefälschte Konten erstellen oder betrügerische Handlungen vornehmen</li>
        <li>Personenbezogene Daten von professionellen Nutzern oder anderen Verbrauchern missbrauchen</li>
        <li>Beleidigende, bedrohliche oder diskriminierende Sprache verwenden</li>
        <li>
          Professionelle Nutzer oder andere Verbraucher belästigen (Belästigung umfasst verbale oder
          schriftliche Äußerungen, die darauf abzielen, psychischen oder physischen Schaden zuzufügen)
        </li>
        <li>Malware, Viren oder schädliche Software hochladen</li>
        <li>Inhalte der Plattform ohne schriftliche Genehmigung kopieren, verbreiten oder vervielfältigen</li>
        <li>Marken, Branding oder die Identität des Unternehmens ohne Zustimmung verwenden</li>
      </ul>
      <p>
        Nutzer dürfen KI-Funktionen nicht missbrauchen, keine falschen oder irreführenden
        Symptominformationen übermitteln und nicht versuchen, über die Plattform medizinische Diagnosen zu
        erstellen.
      </p>
      <p>
        Die wichtigsten Werte, die die Plattform leiten, sind Wertschätzung und Respekt. Diskriminierung
        aufgrund von Geschlecht, Geschlechtsidentität, Nationalität, Religion, Behinderung, sexueller
        Orientierung oder Alter ist strengstens untersagt. Werden diese Regeln nicht eingehalten, kann das
        Unternehmen:
      </p>
      <ul>
        <li>Ihr Konto unverzüglich sperren</li>
        <li>den Vertrag kündigen</li>
        <li>sich an die Strafverfolgungsbehörden wenden</li>
        <li>Schadensersatz und andere Rechtsmittel geltend machen</li>
      </ul>

      <h2>10. RECHTE AN GEISTIGEM EIGENTUM</h2>
      <h3>10.1 Rechte des Unternehmens</h3>
      <p>
        Alle Inhalte, das Design, Marken, Logos und die Software auf der Plattform sind das ausschließliche
        Eigentum des Unternehmens und durch Urheber-, Marken- und andere Rechte an geistigem Eigentum
        geschützt. KI-generierte Inhalte können automatisch erstellten Text enthalten. Diese Inhalte sind
        Eigentum des Unternehmens oder von diesem lizenziert und werden ausschließlich für den persönlichen,
        informativen Gebrauch bereitgestellt.
      </p>
      <p>Es ist Ihnen untersagt:</p>
      <ul>
        <li>Inhalte der Plattform ohne vorherige schriftliche Zustimmung zu kopieren, zu vervielfältigen, zu verbreiten oder anzuzeigen</li>
        <li>Die Marke oder das Branding des Unternehmens zur Kennzeichnung oder Werbung für Produkte oder Dienstleistungen Dritter zu verwenden</li>
        <li>die Software oder Systeme der Plattform zurückzuentwickeln, zu disassemblieren oder zu stören</li>
      </ul>
      <p>
        Markenschutz: „VivianLab“ ist eine eingetragene Marke, die gemäß Artikel 6a der Pariser
        Verbandsübereinkunft und der Richtlinie (EU) 2015/2436 des Europäischen Parlaments und des Rates vom
        16. Dezember 2015 zur Angleichung der Rechtsvorschriften der Mitgliedstaaten über die Marken geschützt
        ist.
      </p>
      <h3>10.2 Nutzerinhalte</h3>
      <p>
        Durch das Hochladen von Inhalten auf Ihr Profil oder die Plattform (einschließlich Fotos,
        Bewertungen und Kommentare):
      </p>
      <ul>
        <li>behalten Sie das Eigentum an Ihren Inhalten;</li>
        <li>
          gewähren Sie dem Unternehmen eine nicht ausschließliche, weltweite und gebührenfreie Lizenz zur
          Nutzung, Darstellung und Verbreitung Ihrer Inhalte auf der Plattform zum Zweck der Bereitstellung der
          Dienste;
        </li>
        <li>
          versichern Sie, dass Sie über alle erforderlichen Rechte an diesen Inhalten verfügen und dass diese
          keine Rechte Dritter verletzen.
        </li>
      </ul>

      <h2>11. HAFTUNGSBESCHRÄNKUNG</h2>
      <h3>11.1 Haftungsbeschränkung des Unternehmens</h3>
      <p>
        Die Plattform dient ausschließlich zu Informations- und Vermittlungszwecken. Sie bietet keine
        medizinische, gesundheitliche oder fachliche Beratung oder Dienstleistungen an.
      </p>
      <p>Soweit gesetzlich zulässig:</p>
      <p>Das Unternehmen haftet nicht für:</p>
      <ul>
        <li>den Inhalt, die Qualität oder das Ergebnis der von professionellen Nutzern erbrachten Dienstleistungen</li>
        <li>Stornierungen, Nichterscheinen oder nicht wahrgenommene Termine</li>
        <li>Schäden, Verluste oder Verletzungen, die sich aus den Dienstleistungen oder Interaktionen mit professionellen Nutzern ergeben</li>
        <li>Einnahmeausfälle, entgangene Gewinne, Vertragsverluste oder besondere, indirekte oder Folgeschäden</li>
      </ul>
      <p>
        Die Plattform wird „wie besehen“ ohne jegliche Gewährleistung (weder ausdrücklich noch stillschweigend)
        bereitgestellt, einschließlich, aber nicht beschränkt auf Gewährleistungen der Marktgängigkeit, der
        Eignung für einen bestimmten Zweck oder des unterbrechungsfreien Betriebs.
      </p>
      <p>
        Diese Haftungsbeschränkung schließt jedoch die Haftung des Unternehmens nicht aus und beschränkt sie
        nicht für: Tod oder Körperverletzung, die auf eigene Fahrlässigkeit oder vorsätzliches Fehlverhalten des
        Unternehmens zurückzuführen sind; jegliche zwingende gesetzliche Haftung, die gesetzlich nicht
        ausgeschlossen werden kann.
      </p>
      <h3>11.2 Hinweis zu Plattform &amp; KI-Tools</h3>
      <p>
        Die Plattform, einschließlich aller KI-gestützten Tools, Wellness-Einblicke, Symptomvorschläge,
        Aufklärungsinhalte und digitalen Funktionen, dient ausschließlich allgemeinen Informations- und
        Wellnesszwecken. Von KI generierte Ergebnisse können ungenau, unvollständig, veraltet oder inkonsistent
        sein und dürfen nicht als Grundlage für medizinische oder klinische Entscheidungen herangezogen werden.
        Die Plattform und ihre KI-Tools dienen nicht der Diagnose, Behandlung, Vorbeugung oder Überwachung von
        Erkrankungen, einschließlich Symptomen im Zusammenhang mit den Wechseljahren. Verbraucher müssen für
        medizinische Beratung zugelassene medizinische Fachkräfte konsultieren. KI-Systeme können inhärente
        Einschränkungen aufweisen, einschließlich Verzerrungen, Halluzinationen oder unvorhersehbarer
        Ergebnisse. Die KI-Funktionen sind nicht dazu bestimmt, Krankheiten nach geltendem US-Recht zu
        diagnostizieren, zu behandeln, zu heilen oder zu verhindern.
      </p>
      <h3>11.3 Keine Haftung für KI-Inhalte oder Wellness-Hinweise</h3>
      <p>Soweit dies nach geltendem Recht zulässig ist, haftet das Unternehmen nicht für:</p>
      <ul>
        <li>das Vertrauen des Verbrauchers auf KI-generierte Inhalte, Wellness-Empfehlungen oder die Interpretation von Symptomen</li>
        <li>Entscheidungen, die auf der Grundlage von KI-Ergebnissen oder Bildungsinhalten getroffen werden</li>
        <li>körperliche, psychische oder emotionale Folgen, die sich aus der Nutzung von KI-Tools ergeben</li>
      </ul>
      <p>
        Der Verbraucher bleibt allein verantwortlich für die Bewertung und Überprüfung aller über die Plattform
        bereitgestellten Informationen, bevor er Maßnahmen ergreift. Das Unternehmen haftet nicht für Schäden,
        die sich aus den inhärenten Einschränkungen von KI-Systemen ergeben.
      </p>
      <h3>11.4 Keine Haftung für Dienstleistungen professioneller Nutzer</h3>
      <p>
        Professionelle Nutzer sind als unabhängige Auftragnehmer tätig und nicht als Angestellte, Beauftragte
        oder Vertreter des Unternehmens. Das Unternehmen übernimmt keine Gewähr für die Richtigkeit oder
        Vollständigkeit der Angaben der professionellen Nutzer, ihre Qualifikationen, Lizenzen, Zertifizierungen
        oder Kompetenzen, oder die Qualität, das Ergebnis oder die Erfüllung der von ihnen erbrachten
        Dienstleistungen. Das Unternehmen übernimmt keine Verantwortung für Stornierungen, Nichterscheinen,
        Unzufriedenheit mit den Dienstleistungen oder die Folgen von Ratschlägen, die von professionellen Nutzern
        erteilt werden.
      </p>
      <h3>11.5 Technische Probleme</h3>
      <p>Das Unternehmen haftet nicht für:</p>
      <ul>
        <li>Dienstunterbrechungen</li>
        <li>Verzögerungen oder Ausfälle aufgrund von Netzwerkproblemen oder Problemen mit den Geräten der Nutzer</li>
        <li>Datenverluste</li>
        <li>Inkompatibilität mit der Hardware oder Software des Verbrauchers</li>
        <li>Systemausfälle bei Dritten (einschließlich Hosting-Anbietern, Videokonferenzdiensten oder Zahlungsabwicklern)</li>
      </ul>
      <h3>11.6 Allgemeine Beschränkung</h3>
      <p>Sofern nicht gesetzlich verboten, haftet das Unternehmen nicht für:</p>
      <ul>
        <li>Entgangenen Gewinn oder Umsatz</li>
        <li>Seelische Belastung</li>
        <li>Datenverlust oder Verlust des Firmenwerts</li>
        <li>Indirekte, zufällige, Straf- oder Folgeschäden</li>
        <li>
          Jegliche Schäden, die sich aus der missbräuchlichen Nutzung der Plattform, Verstößen gegen die
          Nutzungsbedingungen oder dem unberechtigten Vertrauen auf Inhalte der Plattform ergeben
        </li>
      </ul>
      <h3>11.7 Verantwortung professioneller Nutzer</h3>
      <p>
        Professionelle Nutzer sind selbstständige Auftragnehmer und keine Mitarbeiter oder Beauftragten des
        Unternehmens. Professionelle Nutzer sind allein verantwortlich für den Inhalt, die Qualität und die
        Erbringung ihrer Dienstleistungen sowie ihre eigenen Berufszulassungen, Versicherungen und die Einhaltung
        geltender Gesetze. Das Unternehmen übernimmt keine Gewähr für die Qualifikationen, die Kompetenz oder
        die Dienstleistungen der professionellen Nutzer.
      </p>

      <h2>12. HÖHERE GEWALT</h2>
      <p>
        Das Unternehmen haftet nicht für die Nichterfüllung von Verpflichtungen, wenn diese auf Ereignisse
        zurückzuführen ist, die außerhalb seiner zumutbaren Kontrolle liegen, einschließlich, aber nicht
        beschränkt auf: höhere Gewalt, Naturkatastrophen; Krieg, Terrorismus, Unruhen; Streiks oder
        Arbeitskräftemangel; Störungen der Kommunikationsnetze; Ausfall von Zahlungsdienstleistern; Maßnahmen der
        Regierung oder gesetzliche Beschränkungen. Tritt ein Ereignis höherer Gewalt ein, wird das Unternehmen
        die betroffenen Verbraucher innerhalb von 15 Tagen benachrichtigen und eine Schätzung der voraussichtlichen
        Dauer vorlegen. Störungen von KI-Diensten oder APIs von Drittanbietern stellen ebenfalls Ereignisse höherer
        Gewalt dar.
      </p>

      <h2>13. KÜNDIGUNG UND SPERRUNG</h2>
      <h3>13.1 Kündigung durch das Unternehmen</h3>
      <p>
        Das Unternehmen kann den Zugang eines Verbrauchers zur Plattform ohne vorherige Ankündigung unverzüglich
        aussetzen oder beenden, wenn der Verbraucher gegen diese Nutzungsbedingungen verstößt; illegale,
        betrügerische oder schädliche Aktivitäten ausübt; das Unternehmen eine gerichtliche Anordnung, eine
        behördliche Anweisung oder eine behördliche Mitteilung erhält; oder die fortgesetzte Erbringung von
        Dienstleistungen das Unternehmen einem rechtlichen oder Reputationsrisiko aussetzen würde. Das
        Unternehmen kann außerdem die KI-Funktionalität aussetzen oder einschränken, wenn dies zur Erfüllung
        regulatorischer Verpflichtungen, zur Risikominderung oder aus Sicherheitsgründen gemäß dem EU-KI-Gesetz
        erforderlich ist. Nach Ergreifen solcher Maßnahmen erfolgt eine schriftliche Benachrichtigung.
      </p>
      <h3>13.2 Kündigung durch Verbraucher</h3>
      <p>Verbraucher können diesen Vertrag jederzeit kündigen, indem sie:</p>
      <ul>
        <li>ihr Konto über die Einstellungen der Plattform schließen; oder</li>
        <li>eine schriftliche Mitteilung an das Unternehmen senden.</li>
      </ul>
      <p>
        Nach der Kündigung löscht oder bewahrt das Unternehmen personenbezogene Daten gemäß der{' '}
        <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> und den geltenden
        Rechtsvorschriften auf.
      </p>
      <h3>13.3 Folgen der Kündigung</h3>
      <p>Bei Beendigung:</p>
      <ul>
        <li>Sie haben keinen Zugriff mehr auf die Plattform.</li>
        <li>Alle aktiven Abonnements werden gekündigt (keine Rückerstattung für nicht genutzte Zeiträume).</li>
        <li>Die Daten werden gemäß der Datenschutzerklärung behandelt.</li>
        <li>
          Alle Bestimmungen, die über die Beendigung hinaus gelten sollen (einschließlich Vertraulichkeit und
          Haftung), bleiben weiterhin in Kraft.
        </li>
      </ul>
      <p>
        Durch KI gewonnene Daten können in anonymisierter Form zu Sicherheitszwecken, für Prüfungszwecke oder zur
        Modellverbesserung in Übereinstimmung mit der DSGVO aufbewahrt werden.
      </p>

      <h2>14. ÄNDERUNG DER BEDINGUNGEN</h2>
      <p>
        Das Unternehmen kann diese Nutzungsbedingungen, die Datenschutzerklärung und damit verbundene Richtlinien
        jederzeit aus verschiedenen rechtlichen Gründen ändern. Sollte eine Änderung Ihren Zugang zur Plattform oder
        deren Nutzung wesentlich und nachteilig beeinträchtigen, wird das Unternehmen Sie im Voraus darüber
        informieren. Sie haben dann das Recht, den Vertrag innerhalb von 30 Tagen nach Inkrafttreten der Änderung zu
        kündigen. Die fortgesetzte Nutzung der Plattform nach Inkrafttreten der Änderungen gilt als Zustimmung zu den
        geänderten Bedingungen.
      </p>

      <h2>15. ÜBERTRAGUNG VON RECHTEN</h2>
      <p>
        Verbraucher dürfen Rechte oder Pflichten aus diesem Vertrag nicht ohne die vorherige schriftliche
        Zustimmung des Unternehmens abtreten. Das Unternehmen kann seine Rechte und Pflichten aus diesem Vertrag
        nach eigenem Ermessen an Dritte abtreten (z. B. im Zusammenhang mit einer Fusion, einer Übernahme oder einem
        Unternehmensverkauf).
      </p>

      <h2>16. RECHT UND GERICHTSSTAND</h2>
      <h3>16.1 Anwendbares Recht</h3>
      <p>
        Diese Vereinbarung unterliegt griechischem Recht, auch wenn der Zugriff auf die Plattform von außerhalb
        Griechenlands erfolgt. Fragen im Zusammenhang mit der Transparenz, Voreingenommenheit, Sicherheit oder
        Rechenschaftspflicht von KI sind, soweit relevant, im Einklang mit den geltenden Bestimmungen des
        EU-KI-Gesetzes auszulegen. Keine Bestimmung dieser Bedingungen schränkt zwingende Verbraucherschutzrechte
        ein, die nach den Gesetzen des Landes, in dem der Nutzer seinen Wohnsitz hat, gelten.
      </p>
      <h3>16.2 Streitbeilegung</h3>
      <p>
        Jede Streitigkeit wird zunächst einer Mediation gemäß der Mediationsverordnung des griechischen
        Justizministeriums unterzogen. Kann die Streitigkeit nicht durch Mediation beigelegt werden, wird sie
        ausschließlich durch ein Schiedsverfahren nach den Regeln eines institutionellen Schiedsgerichts oder durch
        die Gerichte von Athen entschieden.
      </p>
      <h3>16.3 Salvatorische Klausel</h3>
      <p>
        Sollte eine Bestimmung dieser Vereinbarung von einem Gericht für ungültig oder nicht durchsetzbar erklärt
        werden, bleiben die übrigen Bestimmungen davon unberührt und weiterhin in vollem Umfang gültig.
      </p>

      <h2>17. GESAMTE VEREINBARUNG</h2>
      <p>
        Diese Nutzungsbedingungen und die Datenschutzerklärung stellen die gesamte Vereinbarung zwischen dem
        Verbraucher und dem Unternehmen dar und ersetzen alle früheren Vereinbarungen. Andere Bedingungen sind nur
        dann verbindlich, wenn sie vom Unternehmen schriftlich bestätigt wurden.
      </p>

      <h2>18. KONTAKTINFORMATIONEN</h2>
      <p>
        Unternehmen: VIVIANLAB LTD
        <br />
        Adresse: 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1
        <br />
        E-Mail: info@vivianlab.com
        <br />
        VAT: BG207933919
      </p>

      <h2>19. WICHTIGER HINWEIS: RESPEKT UND WERTSCHÄTZUNG</h2>
      <p>
        Die Plattform basiert auf den Werten Respekt und Wertschätzung. Missbrauch von KI-Tools zur Erstellung
        beleidigender, schädlicher oder diskriminierender Inhalte ist strengstens untersagt. Nulltoleranz gegenüber
        beleidigender Sprache, Diskriminierung und Belästigung.
      </p>

      <h2>KI-TRANSPARENZERKLÄRUNG</h2>
      <p>
        Die Plattform umfasst KI-basierte Funktionen, die automatisierte Inhalte generieren. Wenn Sie diese
        Funktionen nutzen, erkennen Sie an, dass Sie mit einem KI-System kommunizieren. KI-Ergebnisse dürfen nicht als
        Grundlage für medizinische Diagnosen oder dringende Entscheidungen herangezogen werden. Die Nutzung erfordert
        Ihre ausdrückliche Zustimmung. Die KI-Systeme führen keine automatisierte Entscheidungsfindung mit rechtlich
        schwerwiegenden Auswirkungen durch. Nutzer können Klarstellung zur KI-Verarbeitung vom Unternehmen
        anfordern.
      </p>
      <p>
        <strong>
          DIESE NUTZUNGSBEDINGUNGEN FÜR VERBRAUCHER WURDEN ZULETZT AM 12.05.2025 GEÄNDERT.
        </strong>
      </p>
      <p>
        Durch Klicken auf „Ich stimme zu“ oder durch die Nutzung der Plattform bestätigen Sie, dass Sie diese
        Nutzungsbedingungen und die <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink>{' '}
        gelesen und verstanden haben.
      </p>
    </div>
  );
}

export default ConsumerTermsGerman;
